module.exports = __webpack_public_path__ + "img/gb_left@2x.1e4f0025.png";